import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const propertiesRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTIES,
    name: 'PROPERTIES',
    component: () => import('./pages/PropertiesPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.ARCHIVED_PROPERTIES,
    name: 'ARCHIVED_PROPERTIES',
    component: () => import('./pages/ArchivedPropertiesPage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    path: routes.PROPERTIES_ENRICHMENT,
    name: 'PROPERTIES_ENRICHMENT',
    component: () => import('./pages/PropertyOpsEnrichmentPage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    path: routes.PROPERTIES_VERIFICATION,
    name: 'PROPERTIES_VERIFICATION',
    component: () => import('./pages/PropertiesVerificationPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.PROPERTIES_COMPLIANCE,
    name: 'PROPERTIES_COMPLIANCE',
    component: () => import('./pages/PropertiesCompliancePage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.PROPERTIES_FINANCIAL_SETUP,
    name: 'PROPERTIES_FINANCIAL_SETUP',
    component: () => import('./pages/PropertiesFinancialSetupPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.PROPERTIES_CO_OWNER_KYC,
    name: 'PROPERTIES_CO_OWNER_KYC',
    component: () => import('./pages/PropertiesCoOwnerKycPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.PROPERTIES_VASP,
    name: 'PROPERTIES_VASP',
    component: () => import('./pages/PropertiesVaspPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.PROPERTIES_PIPELINE,
    name: 'PROPERTIES_PIPELINE',
    component: () => import('./pages/PropertiesPipelinePage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.PROPERTIES_REJECTED,
    name: 'PROPERTIES_REJECTED',
    component: () => import('./pages/PropertiesRejectedPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.PROPERTIES_RENTAL_REFRESH,
    name: 'PROPERTIES_RENTAL_REFRESH',
    component: () => import('./pages/RentalRefreshQueuePage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    path: routes.PROPERTIES_VALUATION_REFRESH,
    name: 'PROPERTIES_VALUATION_REFRESH',
    component: () => import('./pages/ValuationRefreshQueuePage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    path: routes.PROPERTIES_DRAFT,
    name: 'PROPERTIES_DRAFT',
    component: () => import('./pages/PropertiesDraftPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    // Create wizard (fresh). Resume route below shares the same page.
    path: routes.ADD_PROPERTY,
    name: 'ADD_PROPERTY',
    component: () => import('./pages/PropertyCreatePage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    // Resume an existing draft — /properties/:id/create?step=N. Same wizard page.
    path: routes.EDIT_PROPERTY,
    name: 'EDIT_PROPERTY',
    component: () => import('./pages/PropertyCreatePage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    // Ops-enrichment wizard — /properties/:id/enrich. Reached from the
    // Enrichment queue's "Enrich" action; guided highlights → amenities →
    // documents → media flow that ends in submit-for-verification.
    path: routes.PROPERTY_ENRICHMENT_WIZARD,
    name: 'PROPERTY_ENRICHMENT_WIZARD',
    component: () => import('./pages/PropertyEnrichmentWizardPage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    // Full-page financials add/edit (Fin Admin). Defined before PROPERTY_DETAILS
    // so the more-specific '/:id/financials' path matches first.
    path: routes.PROPERTY_FINANCIALS_EDIT,
    name: 'PROPERTY_FINANCIALS_EDIT',
    component: () => import('./pages/PropertyFinancialsEditPage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    path: routes.PROPERTY_DETAILS,
    name: 'PROPERTY_DETAILS',
    component: () => import('./pages/PropertyDetailsPage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
  {
    path: routes.PROPERTY_QUICK_DETAILS,
    name: 'PROPERTY_QUICK_DETAILS',
    component: () => import('./pages/PropertyQuickDetailsPage.vue'),
    meta: { requiresAuth: true, permission: 'view_properties', activeMenu: 'Properties' },
  },
]
